import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfService } from './TermsOfService';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-gray-900 text-gray-300 py-8 px-4" data-id="element-1">
        <div className="max-w-4xl mx-auto" data-id="element-2">
          <div className="flex flex-col items-center justify-center space-y-4" data-id="element-3">
            <div className="flex items-center gap-6 text-sm" data-id="element-4">
              <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors underline focus:outline-none focus:ring-2 focus:ring-emerald-500 rounded px-2 py-1" data-id="element-5">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-6">|</span>
              <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors underline focus:outline-none focus:ring-2 focus:ring-emerald-500 rounded px-2 py-1" data-id="element-7">
                Términos y Condiciones
              </button>
            </div>
            <p className="text-sm text-gray-500" data-id="element-8">
              © {new Date().getFullYear()} Guías Para Vivir. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-9">
        <PrivacyPolicy data-id="element-10" />
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-11">
        <TermsOfService data-id="element-12" />
      </Modal>
    </>;
}